import React, {Component} from 'react'
import {Row, Col, Input} from 'reactstrap'
import {Query} from 'react-apollo'

import AUSelectGenerator from '../auto_updaters/Select'
import query from '../../../queries/server/filter_timesheet_users'

const AUSelectOffices = AUSelectGenerator('offices', 'id description', 'id', ['description'])

export default class TimesheetFilters extends Component{

    render(){

        const {onUserChange, onActiveChange, onOfficeChange, selectedUserId, active, officeId} = this.props

        return(
            <Row>
                <Col>
                    <Input type="select" size="sm" value={active} onChange={evt => onActiveChange(evt.target.value)}>
                        <option value="1">
                            Current Users
                        </option>
                        <option value="">
                            All Users
                        </option>
                    </Input>
                </Col>

                <Col>
                    <AUSelectOffices
                        value={officeId}
                        defaultLabel="All Offices"
                        size="sm"
                        onChange={office_id => onOfficeChange(office_id)}
                    />
                </Col>

                <Col>
                    <Query query={query} variables={{active, office_id: officeId}} fetchPolicy="network-only">
                        {({data, loading, error}) => {

                            if(loading) return <span className="lead">Loading...</span>

                            return(<Input type="select" size="sm" value={selectedUserId} onChange={evt => onUserChange(evt.target.value)}>
                                <option>---Select User---</option>
                                {data.filter_users.map(({user_id, full_name}) => (
                                    <option value={user_id}>{full_name}</option>
                                ))}
                            </Input>)
                        }}
                    </Query>
                </Col>
            </Row>
        )

    }

}